// @flow
import React, { PureComponent } from 'react';
import { getDateFromString, getMonthName } from 'utils/dateUtils';
import { MOBILE_SIZE } from 'constants/app';

import EventListElementSimple from 'components/event/EventListElementSimple';
import EventListElementMatch from 'containers/event/EventListElementMatchContainer';

type Props = {
  event: any,
  isFirst?: boolean
};

class EventListElementWrapper extends PureComponent<Props> {
  renderElement() {
    const event: any = this.props.event;

    if (event.compTag) {
      return <EventListElementMatch event={event} />;
    } else {
      return <EventListElementSimple event={event} />;
    }
  }

  render() {
    const {
      isFirst,
      event: { endDate, startDate, compTag }
    } = this.props;
    /**
     * Sur mobile et si c'est un match seul à annoncer, ne pas afficher la date
     * pour gagner de l'espace
     */
    if (window.innerWidth < MOBILE_SIZE && compTag) {
      return <div className="event-row event-row--large">{this.renderElement()}</div>;
    }

    // desktop render
    const date = getDateFromString(startDate);
    const dateEnd = getDateFromString(endDate);
    let dayStart = `${date.getUTCDate() < 10 ? '0' : ''}${date.getUTCDate()}`;
    let monthStart = getMonthName(parseInt(date.getUTCMonth(), 0));
    const monthEnd = getMonthName(parseInt(dateEnd.getUTCMonth(), 0));
    const dayEnd = `${dateEnd.getUTCDate() < 10 ? '0' : ''}${dateEnd.getUTCDate()}`;
    if (!compTag && dayStart !== dayEnd && monthStart === monthEnd) {
      dayStart = `${dayStart} - ${dayEnd}`;
    }
    if (!compTag && monthStart !== monthEnd) {
      dayStart = `${dayStart} | ${dayEnd}`;
      monthStart = `${monthStart} | ${monthEnd}`;
    }

    return (
      <div className="event-row event-row--large">
        <p className="event__date">
          {isFirst && (
            <>
              <span className="event__day ft-h2">{dayStart}</span>
              <br />
              <span className="event__month ft-h6 ft-up">{monthStart}</span>
            </>
          )}
        </p>
        {this.renderElement()}
      </div>
    );
  }
}

export default EventListElementWrapper;
